import * as React from "react";

export class AudioPlayer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            play: false
        }
    }

    audio = new Audio(this.props.url,)



    componentDidMount() {
        this.audio.addEventListener('ended', () => this.setState({ play: false }));
    }

    componentWillUnmount() {
        this.audio.removeEventListener('ended', () => this.setState({ play: false }));
    }

    togglePlay = () => {
        this.setState({ play: !this.state.play }, () => {
            this.state.play ? this.audio.play() : this.audio.pause();
        });
    }

    render() {
        return (
            <div>
                <audio ref="audio_tag" controls >
                    <source src={this.props.url}  type="audio/mp3"/>
                </audio>
                {/*<button onClick={this.togglePlay}>{this.state.play ? 'Pause' : 'Play'}</button>*/}
            </div>
        );
    }
}
